if (!customElements.get("el-product-accordion-group")) {
  class ElProductAccordionGroup extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === "true") return;
      this.dataset.initialized = "true";

      const items = [...this.querySelectorAll("[data-el-accordion-item]")];
      const opened = items.filter((item) => item.classList.contains("is-open"));

      opened.forEach((item, index) => {
        this.setItem(item, index === 0);
      });

      items.forEach((item) => {
        if (!item.classList.contains("is-open")) {
          this.setItem(item, false);
        }
      });

      this.addEventListener("click", (event) => {
        const trigger = event.target.closest("[data-el-accordion-trigger]");
        if (!trigger) return;

        const item = trigger.closest("[data-el-accordion-item]");
        if (!item) return;

        const shouldOpen = !item.classList.contains("is-open");

        if (shouldOpen) {
          items.forEach((otherItem) => {
            if (otherItem !== item) {
              this.setItem(otherItem, false);
            }
          });
        }

        this.setItem(item, shouldOpen);
      });
    }

    setItem(item, open) {
      item.classList.toggle("is-open", open);

      const trigger = item.querySelector("[data-el-accordion-trigger]");

      if (trigger) {
        trigger.setAttribute("aria-expanded", open ? "true" : "false");
      }
    }
  }

  customElements.define("el-product-accordion-group", ElProductAccordionGroup);
}

if (!customElements.get("el-product-video-swiper")) {
  class ElProductVideoSwiper extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === "true") return;
      this.dataset.initialized = "true";

      this.videos = [...this.querySelectorAll("[data-el-product-video]")];

      this.videos.forEach((video) => {
        const media = video.closest("[data-el-video-card]");

        video.addEventListener("play", () => {
          media?.classList.add("is-playing");

          this.videos.forEach((otherVideo) => {
            if (otherVideo !== video && !otherVideo.paused) {
              otherVideo.pause();
            }
          });
        });

        video.addEventListener("pause", () => {
          media?.classList.remove("is-playing");
        });

        video.addEventListener("ended", () => {
          media?.classList.remove("is-playing");
        });
      });

      this.addEventListener("click", (event) => {
        const playButton = event.target.closest("[data-el-video-play]");

        if (playButton) {
          const video = playButton
            .closest("[data-el-video-card]")
            ?.querySelector("[data-el-product-video]");

          this.toggleVideo(video);
          return;
        }

        const video = event.target.closest("[data-el-product-video]");

        if (video) {
          this.toggleVideo(video);
        }
      });
    }

    toggleVideo(video) {
      if (!video) return;

      if (video.paused || video.ended) {
        this.videos.forEach((otherVideo) => {
          if (otherVideo !== video && !otherVideo.paused) {
            otherVideo.pause();
          }
        });

        const playPromise = video.play();

        if (playPromise?.catch) {
          playPromise.catch(() => {});
        }
      } else {
        video.pause();
      }
    }
  }

  customElements.define("el-product-video-swiper", ElProductVideoSwiper);
}
